// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"43bbcbad","149":"6980c195","248":"723390e8","439":"6980c195","482":"6980c195","552":"6980c195","959":"6980c195","993":"6980c195"}[chunkId] + ".chunk.css";
};